export enum DataSource {
	OKIS = 1,
	EPORTALAS = 2,
	PUSRIS = 3,
	BIIP = 4,
	RASFF = 5,
	PERSONALREPORTS = 6,
}
